export enum IStatusResultEnum {
    Error = 'ERROR',
    Processing = 'PROCESSING',
    Success = 'SUCCESS'
  }